"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Process() {
  const steps = [{
    number: "01",
    title: "ÉCOUTE VOS BESOINS",
    description: "Un temps d'échange pour comprendre vos préférences alimentaires, vos restrictions et vos profils de saveurs favoris.",
    duration: "ÉCHANGE"
  }, {
    number: "02",
    title: "CRÉATION DES MENUS",
    description: "Conception de plans de repas personnalisés et équilibrés, adaptés spécifiquement à votre phase de récupération.",
    duration: "CRÉATION"
  }, {
    number: "03",
    title: "SOURCING LOCAL",
    description: "Sélection rigoureuse d'ingrédients bio et locaux en partenariat avec des producteurs passionnés de notre région.",
    duration: "SÉLECTION"
  }, {
    number: "04",
    title: "CUISSON & LIVRAISON",
    description: "Préparation artisanale de vos plats à domicile, suivie d'une livraison soignée pour préserver toute la fraîcheur.",
    duration: "SERVICE"
  }, {
    number: "05",
    title: "NOURRITURE CONSCIENTE",
    description: "Savourez des repas conçus pour la vitalité, alliant plaisir culinaire et philosophie de soin postnatal.",
    duration: "VITALITÉ"
  }];
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: timelineRef,
    isVisible: timelineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return;
}